import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.344 3c.467 0 .844.376.844.844v.281c0 .619.291 1.202.787 1.575a3.66 3.66 0 0 1 1.463 2.925v.281a.84.84 0 0 1-.844.844.84.84 0 0 1-.844-.844v-.281c0-.619-.292-1.202-.787-1.575A3.66 3.66 0 0 1 7.5 4.125v-.281c0-.468.376-.844.844-.844m-.018 15.205c.404.183.717.517.88.928.041.11.147.18.263.18h5.062c.116 0 .222-.07.264-.18.158-.411.475-.745.879-.928a6.19 6.19 0 0 0 3.639-5.642H4.688a6.19 6.19 0 0 0 3.638 5.642M3 12.563c0-.932.756-1.688 1.688-1.688h14.625c.931 0 1.687.756 1.687 1.688a7.88 7.88 0 0 1-4.63 7.178A1.97 1.97 0 0 1 14.53 21H9.47a1.97 1.97 0 0 1-1.839-1.259A7.88 7.88 0 0 1 3 12.563m10.688-8.72v.282c0 .619.291 1.202.787 1.575a3.66 3.66 0 0 1 1.463 2.925v.281a.84.84 0 0 1-.844.844.84.84 0 0 1-.844-.844v-.281c0-.619-.292-1.202-.787-1.575A3.66 3.66 0 0 1 12 4.125v-.281c0-.468.376-.844.844-.844s.844.376.844.844"
    }, null, -1)
  ]))]))
}
export default { render: render }